import React from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import type { HelloWorldValues } from '../schema';

/**
 * Step 3 — review screen. No input fields; displays the values collected
 * in the previous steps before the user confirms and submits.
 */

const ReviewTable = styled.dl`
  margin: 0;
  max-width: 480px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid ${({ theme }) => String(theme.colors.general_dividers ?? '#DADADA')};

  &:last-child {
    border-bottom: none;
  }
`;

const RowLabel = styled.dt`
  font-weight: 600;
  color: ${({ theme }) => String(theme.colors.general_font_secondary)};
  margin: 0;
`;

const RowValue = styled.dd`
  margin: 0;
  color: ${({ theme }) => String(theme.colors.general_font_primary)};
`;

const Intro = styled.p`
  margin: 0 0 16px;
  color: ${({ theme }) => String(theme.colors.general_font_secondary)};
`;

export const Step3: React.FC = () => {
  const { getValues } = useFormContext<HelloWorldValues>();
  const values = getValues();

  return (
    <div style={{ maxWidth: 480 }}>
      <Intro>Review your information before submitting:</Intro>
      <ReviewTable>
        <Row><RowLabel>First name</RowLabel><RowValue>{values.firstName || '—'}</RowValue></Row>
        <Row><RowLabel>Last name</RowLabel><RowValue>{values.lastName || '—'}</RowValue></Row>
        <Row><RowLabel>Email</RowLabel><RowValue>{values.email || '—'}</RowValue></Row>
        <Row><RowLabel>Newsletter</RowLabel><RowValue>{values.newsletter ? 'Yes' : 'No'}</RowValue></Row>
      </ReviewTable>
    </div>
  );
};
